import React from 'react';
import { Section } from '../components/ui/Section';
import { ArrowLeft, ExternalLink } from 'lucide-react';
interface NowPageProps {
  onBack: () => void;
}
export function NowPage({
  onBack
}: NowPageProps) {
  return <main className="min-h-screen bg-background text-foreground pt-32 pb-24 px-6" data-id="element-175">
      <div className="max-w-3xl mx-auto space-y-16" data-id="element-176">
        <button onClick={onBack} className="group flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors" data-id="element-177">
          <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-178" />
          Back to Home
        </button>

        <Section className="space-y-8" data-id="element-179">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight" data-id="element-180">Now</h1>
          <p className="text-sm font-mono text-muted-foreground" data-id="element-181">
            Last updated: January 2026
          </p>

          <div className="prose prose-invert prose-lg max-w-none space-y-12" data-id="element-182">
            <div className="space-y-4" data-id="element-183">
              <h3 className="text-2xl font-medium text-foreground" data-id="element-184">
                Current Focus
              </h3>
              <p className="text-muted-foreground leading-relaxed" data-id="element-185">
                I'm scaling LHV Bank's engineering organization in the UK, with
                a focus on growing our Retail banking app and banking services
                businesses. We're building modern, customer-centric banking
                products while maintaining the high standards expected in
                regulated financial services.
              </p>
            </div>

            <div className="space-y-4" data-id="element-186">
              <h3 className="text-2xl font-medium text-foreground" data-id="element-187">Speaking</h3>
              <p className="text-muted-foreground leading-relaxed" data-id="element-188">
                I'm open to speaking at events and on podcasts about engineering
                leadership, team scaling, AI adoption in regulated industries,
                and organisational design. If you'd like me to speak at your
                event, get in touch.
              </p>
            </div>

            <div className="space-y-4" data-id="element-189">
              <h3 className="text-2xl font-medium text-foreground" data-id="element-190">
                Experimenting With
              </h3>
              <p className="text-muted-foreground leading-relaxed" data-id="element-191">
                I'm deep in AI experimentation, trying to settle on a new way of
                working that's AI-native. Currently exploring Claude Code,
                Codex, and Cursor to understand how AI can fundamentally
                change how engineering teams operate, not just as a productivity
                tool but as a shift in how we approach software development.
              </p>
            </div>

            <div className="space-y-4" data-id="element-192">
              <h3 className="text-2xl font-medium text-foreground" data-id="element-193">Building</h3>
              <p className="text-muted-foreground leading-relaxed" data-id="element-194">
                I'm developing an organisational design framework called{' '}
                <strong data-id="element-195">Atomic Team Design</strong>, a way to reason about
                organisations as living systems designed intentionally around
                capability, constraints, and evolution. Details are starting to
                make their way to{' '}
                <a href="https://github.com/atomicteamdesign/atd" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-blue-400 hover:text-blue-300 transition-colors" data-id="element-196">
                  the GitHub repository
                  <ExternalLink size={14} data-id="element-197" />
                </a>
                .
              </p>
            </div>

            <div className="space-y-4" data-id="element-198">
              <h3 className="text-2xl font-medium text-foreground" data-id="element-199">
                No Longer Doing
              </h3>
              <p className="text-muted-foreground leading-relaxed" data-id="element-200">
                I'm not offering consulting services so I can focus fully on my
                role at LHV Bank.
              </p>
            </div>
          </div>
        </Section>
      </div>
    </main>;
}